import React from 'react';
import debug from 'debug';
import {getBackPath} from '../shared/utils/dashboardUtils';
import {Icon, Page, Tile} from '../../shared';
import history from '../../history';
import {RiskManagement} from '../widgets';
import useQueryObject from '../../shared/utils/useQueryObject';

const log = debug('circleblack:investor:page:RiskManagementPage');

const RiskManagementPage = () => {
  log('rendering');

  const [context] = useQueryObject('context');
  const backPath = getBackPath();
  const tileIcon = <Icon svg={'arrowCircle'} rotate={'180deg'} width='20px' height='20px' action={() => history.push(backPath)}/>;

  return <Page>
    <Tile key={'riskManagement'}
          title={'Risk Management'}
          height={'fit-content'}
          minHeight={'270px'}
          icon={tileIcon}>
      <RiskManagement context={context} singleColumn={true}/>
    </Tile>
  </Page>;
};

export default RiskManagementPage;
